if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
      this.cardStyle = this.dataset.cardStyle;
      this.itemSize = this.dataset.itemSize;
      this.columnsDesktop = this.dataset.columnsDesktop;
      this.navigationPosition = this.dataset.navigationPosition || 'middle';
      this.pagination = this.section.querySelector('.swiper-pagination');

      this.sliderInstance = false;

      const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
      mql.onchange = this.init.bind(this);
      this.init();
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      // Each arrow click pages a full row: slidesPerGroup follows
      // slidesPerView at every breakpoint (the featured-collection rails do
      // the same), and with the 'auto' item size Swiper groups whatever fits.
      // The section's pre-init CSS mirrors these breakpoints; keep them in step.
      const fixed = this.itemSize == 'fixed';
      const cols = Number(this.columnsDesktop) || 4;
      const perView = {
        768: fixed ? Math.min(cols, 4) : 'auto',
        1024: fixed ? (cols > 6 ? cols - 1 : cols) : 'auto',
        1280: fixed ? cols : 'auto',
      };
      const breakpoint = (n) => ({
        spaceBetween: this.cardStyle == 'card' ? 8 : 20,
        slidesPerView: n,
        slidesPerGroup: fixed ? n : 1,
      });
      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination, FoxTheme.Swiper.Mousewheel],
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        slidesPerGroupAuto: !fixed,
        spaceBetween: 8,
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination:
          this.navigationPosition == 'bottom' && this.pagination
            ? { el: this.pagination, type: 'progressbar' }
            : false,
        loop: false,
        threshold: 2,
        watchSlidesProgress: true,
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },
        breakpoints: {
          768: breakpoint(perView[768]),
          1024: breakpoint(perView[1024]),
          1280: breakpoint(perView[1280]),
        },
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);

        // The section's inline handler lets the arrows scroll the strip
        // natively before this runs; carry that position over to Swiper.
        const scrolled = this.scrollLeft;
        if (scrolled) this.scrollLeft = 0;

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();

        if (scrolled) {
          // Nearest snap position (a full row, since slidesPerGroup follows
          // slidesPerView), then the first slide of that group.
          const slider = this.sliderInstance.slider;
          const snaps = slider.snapGrid || [];
          let snap = 0;
          for (let i = 0; i < snaps.length; i += 1) {
            if (Math.abs(snaps[i] - scrolled) < Math.abs(snaps[snap] - scrolled)) snap = i;
          }
          slider.slideTo(snap * (slider.params.slidesPerGroup || 1), 0);
        }

        const focusableElements = FoxTheme.a11y.getFocusableElements(this);

        focusableElements.forEach((element) => {
          element.addEventListener('focusin', () => {
            const slide = element.closest('.swiper-slide');
            this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          });
        });

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', (e) => {
            if (e.detail.sectionId != this.sectionId) return;
            let { target } = e;
            const index = Number(target.dataset.index);

            this.sliderInstance.slider.slideTo(index);
          });
        }
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance !== 'object') return;
      this.sliderInstance.slider.destroy();
      this.sliderInstance = false;
    }
  }
  customElements.define('collection-list', CollectionList);
}
